var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"lendingSection2"},[_c('landing-container',[_c('div',{staticClass:"lendingSection2__container"},[_c('public-profile'),_c('join-our-community'),_c('apps'),_c('videos')],1)])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }